/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import ReactivateRoute from 'app/components/RouteList/ReactivateRoute.jsx';
import ErrorHelper from 'app/mixins/ErrorHelper.jsx';
import MessageModule from 'app/mixins/MessageModule.jsx';
import * as _ from 'underscore';
import FormattedRelativeWrapper from 'app/components/common/FormattedRelativeWrapper.jsx';

import ConfirmModal from 'app/components/common/ConfirmModal.jsx';

export default function RouteDetailModule(Component) {

	class RouteDetailModule extends React.Component {
		constructor(props) {
			super(props);

			this.state = {
				reactivating: false,
				firstPullFlag: null,
				reactivatingInput: 0,
				detailError: '',
				isReauthorizing: false
			};

			this.activeRouteToggleClick = this.activeRouteToggleClick.bind(this);
			this.setReactivationAction = this.setReactivationAction.bind(this);
			this.reactivateRoute = this.reactivateRoute.bind(this);
			this.reactivateInput = this.reactivateInput.bind(this);
			this.getReactivateBlock = this.getReactivateBlock.bind(this);
			this.reauthorizeInput = this.reauthorizeInput.bind(this);
			this.upgradeFromReplay = this.upgradeFromReplay.bind(this);
			this.generateReplayBlock = this.generateReplayBlock.bind(this);
			this.generateDetailStatusBlock = this.generateDetailStatusBlock.bind(this);
			this.startReactivation = this.startReactivation.bind(this);
			this.setDetailError = this.setDetailError.bind(this);

		}

		startReactivation(id) {
			let reactivating = this.state.reactivating,
				reactivatingInput = this.state.reactivatingInput;

			if (id) {
				reactivatingInput = id;
				reactivating = true;
			}

			this.setState({
				reactivating,
				reactivatingInput
			});

		}

		setDetailError(detailError) {
			this.setState({
				detailError
			});
		}

		activeRouteToggleClick(event) {
			let active = (event.currentTarget.dataset.togglestate === "true") ? 0 : 1,
				inputs = [],
				constants = this.props.app.config.constants,
				canActivate = true,
				permissionDenied = false;

			if (active) {
				// spin through the inputs to see if they need to be reconnected first for simple routes

				if (parseInt(this.props.app.flags.routeViewType, 10) === constants.ROUTE_VIEW_SIMPLE) {
					inputs = this.props.route.inputs;
					for (let i = 0; i < inputs.length; ++i) {
						if ([constants.INPUT_TYPE_TWITTER,
							 constants.INPUT_TYPE_INSTAGRAM,
							 constants.INPUT_TYPE_INSTAGRAM_BUSINESS,
							 constants.INPUT_TYPE_FACEBOOK_PAGE].indexOf(parseInt(inputs[i].type)) !== -1) {
							if (inputs[i].sysActionFlag && (parseInt(inputs[i].sysActionFlag, 10) === 1 || inputs[i].sysActionFlag === true)) {
								canActivate = false;
							}
						}
						if (inputs[i].type == constants.INPUT_TYPE_TWITTER && this.props.user.detail.pubLevel <= 1) {
							permissionDenied = true;
						}
					}
				}

				if (canActivate && !permissionDenied) {
					this.setState({
						reactivating: true
					});
				} else {
					if (!canActivate) {
						this.setState({
							detailError: 'Reconnect your feed before activating it'
						});
					} else {
						this.props.showUpgradeModal(this.props.closeAllModals, 'twitterInput', null, 'automate_error');
					}
				}
			} else {
				if (parseInt(this.props.app.flags.routeViewType, 10) === constants.ROUTE_VIEW_SIMPLE) {
					let route = this.props.route;
					route.activeFlag = active;
					this.props.updateRoute(route);
					if (this.props.route.inputs.length) {
						let input = this.props.route.inputs[0];
						input.activeFlag = active;
						this.props.updateInput(input);
					}
				} else {
					let route = this.props.route;
					route.activeFlag = active;
					this.props.updateRoute(route);
				}

			}

		}

		setReactivationAction(action) {
			this.setState({
				firstPullFlag: action
			});
		}

		reactivateRoute() {
			let constants = this.props.app.config.constants,
				input = null,
				firstPullFlag = (this.state.firstPullFlag) ? this.state.firstPullFlag : "2";

			let route = this.props.route;
			route.activeFlag = 1;
			route.firstPullFlag = firstPullFlag;
			this.props.updateRoute(route);

			if (parseInt(this.props.app.flags.routeViewType, 10) === constants.ROUTE_VIEW_SIMPLE) {
				if (this.props.route.inputs.length) {
					input = this.props.route.inputs[0];
					input.activeFlag = 1;
					this.props.updateInput(input);
				}
			}

			this.setState({
				reactivating: false
			});
		}

		reactivateInput() {
			let constants = this.props.app.config.constants,
				input = null,
				firstPullFlag = (this.state.firstPullFlag) ? this.state.firstPullFlag : "2";

			input = this.props.findInput(this.state.reactivatingInput);
			input.activeFlag = 1;
			input.firstPullFlag = firstPullFlag;
			input.resetFirstPost = true;
			this.props.updateInput(input);

			this.setState({
				reactivating: false,
				reactivatingInput: 0
			});
		}

		getReactivateBlock(type) {
			let reactivateBlock = null;

			if (type === 'route') {
				reactivateBlock = (
					<ReactivateRoute
						{...this.props}
						route={this.props.route}
						onRadioClick={this.setReactivationAction}
						onFinish={this.reactivateRoute} />
				);
			} else if (type === 'input') {
				reactivateBlock = (
					<ReactivateRoute
						{...this.props}
						route={this.props.route}
						onRadioClick={this.setReactivationAction}
						onFinish={this.reactivateInput} />
				);
			}

			return reactivateBlock;

		}

		reauthorizeInput(e) {
	        let serviceId = e.currentTarget.dataset.serviceid,
	            iaId = e.currentTarget.dataset.id,
				url = "/remote/beginreauth?isID=:isId&iaID=:iaId&state=:state&final=:final",
				date = new Date(),
				state = ['REAUTHINPUT', serviceId, iaId, date.getTime()].join("_"),
				constants = this.props.app.config.constants;

	        e.preventDefault();
	        e.stopPropagation();

			if (parseInt(serviceId) === constants.INPUT_TYPE_TWITTER &&
				this.props.app.config.twitterDisabled !== undefined &&
				this.props.app.config.twitterDisabled === 1) {
				this.props.closeAllModals();
				this.props.addModal(
					<ConfirmModal
						modalCopy="Twitter is currently unavailable. We're working to resolve this issue."
						cancelAction={() => {
							this.props.closeAllModals();
						}}
						showCancel={false}
						confirmAction={() => {
							this.props.closeAllModals();
						}}
						confirmLabel={"OK"}/>
				);
				return;
			}

			if (this.state.isReauthorizing) {
				return;
			}

			this.setState({
				isReauthorizing: true
			}, () => {
				url = url.replace(':isId', serviceId);
				url = url.replace(':iaId', iaId);
				url = url.replace(':state', state);
				url = url.replace(':final', window.encodeURIComponent(window.location.href));
				window.location.assign(url);
			});

	    }

		upgradeFromReplay(e) {
			let source = "(New Feed)",
				promo = (this.props.isFreeUser() || this.props.isStarterUser()) ? 'premium' : 'more-socials';

			if (e.currentTarget.dataset.source !== undefined && e.currentTarget.dataset.source !== '') {
				e.preventDefault();
				source = "(Slim)";
			}

			if (mixpanel) {
				if (promo === 'premium') {
					mixpanel.track("Premium Posting Upgrade Clicked " + source);
				} else {
					mixpanel.track("Add More Socials Upgrade Clicked " + source);
				}
			}

			if (promo === 'premium') {
				if (gtag) {
					gtag('event', 'select_promotion', {
						'promotion_id': 'premium_posts_starter',
						'promotion_name': 'Premium Posting New',
						'creative_name': 'premium_posts_starter.feed_detail.1',
						'creative_slot': 'feed_detail',
						items: [
							{
								item_id: 'dlvrit_1',
								item_name: 'dlvr.it premium plan',
								price: 1.00,
								quantity: 1
							}
						]
					});

					this.props.persistData('gaPromo', {
						'promotion_id': 'premium_posts_starter',
						'promotion_name': 'Premium Posting New',
					});
				}

				if (this.props.recordEvent) {
					this.props.recordEvent({
						pub_id: this.props.user.detail.id,
						event_name: 'Premium Posting Feed Banner View',
						event_data: {
							source: source.match(/\w+/)[0]
						}
					})
				}
			} else {
				if (gtag) {
					gtag('event', 'select_promotion', {
						'promotion_id': 'more_socials_basic',
						'promotion_name': 'Add More Socials New',
						'creative_name': 'more_socials_basic.feed_detail.1',
						'creative_slot': 'feed_detail',
						items: [
							{
								item_id: 'dlvrit_1',
								item_name: 'dlvr.it premium plan',
								price: 1.00,
								quantity: 1
							}
						]
					});

					this.props.persistData('gaPromo', {
						'promotion_id': 'more_socials_basic',
						'promotion_name': 'Add More Socials New',
					});
				}

				if (this.props.recordEvent) {
					this.props.recordEvent({
						pub_id: this.props.user.detail.id,
						event_name: 'Add More Socials Basic Feed Banner View',
						event_data: {
							source: source.match(/\w+/)[0]
						}
					})
				}
			}

			if (this.props.route.inputs.length) {
				this.props.recordPath(window.location.pathname + "/input/" + this.props.route.inputs[0].id);
			}
			if (this.props.isFreeUser()) {
				this.props.router.navigate("account/subscription/new?plan=6");
			} else {
				this.props.router.navigate("account/subscription");
			}

		}

		generateReplayBlock() {
			let actionLabel = "Get Premium Posting",
				clickHandler = this.upgradeFromReplay;

			if (this.props.isFreeUser() || this.props.isStarterUser()) {
				if (mixpanel) {
					mixpanel.track("Premium Posting Upgrade View (New Feed)");
				}

				if (gtag) {
					gtag('event', 'view_promotion', {
						'promotion_id': 'premium_posts_pro',
						'promotion_name': 'Premium Posting New',
						'creative_name': 'premium_posts_pro.feed_detail.1',
						'creative_slot': 'feed_detail',
						items: [
							{
								item_id: 'dlvrit_1',
								item_name: 'dlvr.it premium plan',
								price: 1.00,
								quantity: 1
							}
						]
					});
				}

				if (this.props.recordEvent) {
					this.props.recordEvent({
						pub_id: this.props.user.detail.id,
						event_name: 'Premium Posting Feed Banner View',
						event_data: {
							source: 'New Feed'
						}
					})
				}
			} else {
				if (mixpanel) {
					mixpanel.track("Add More Socials Upgrade View (New Feed)");
				}

				if (gtag) {
					gtag('event', 'view_promotion', {
						'promotion_id': 'more_socials_basic',
						'promotion_name': 'Add More Socials New',
						'creative_name': 'more_socials_basic.feed_detail.1',
						'creative_slot': 'feed_detail',
						items: [
							{
								item_id: 'dlvrit_1',
								item_name: 'dlvr.it premium plan',
								price: 1.00,
								quantity: 1
							}
						]
					});
				}

				if (this.props.recordEvent) {
					this.props.recordEvent({
						pub_id: this.props.user.detail.id,
						event_name: 'Add More Socials Feed Banner View',
						event_data: {
							source: 'New Feed'
						}
					})
				}
			}

			if (this.props.isFreeUser() || this.props.isStarterUser()) {
				return (
					<div className="detail-status replay">
						<div className="replay-icon-wrapper" onClick={clickHandler} role="link" aria-label="upgrade">
							<div className="replay-icon">
								<i className="icon fa fa-star"></i>
							</div>
						</div>
						<div className="replay-copy">
							<h3>Post more than 50 items per month? Unlock Premium Posting</h3>
							<p>Get Basic and unlock unlimited social media posting for essential platforms.</p>
							<div className="replay-button">
								<button className="btn-primary replay" onClick={clickHandler}>
									{actionLabel}
								</button>
							</div>
						</div>
					</div>
				);
			} else {
				actionLabel = "Upgrade Now";
				return (
					<div className="detail-status replay">
						<div className="replay-icon-wrapper" onClick={clickHandler} role="link" aria-label="upgrade">
							<div className="replay-icon">
								<i className="icon ion-android-star-outline"></i>
							</div>
						</div>
						<div className="replay-copy">
							<h3>Need more socials? Find the plan that fits your needs.</h3>
							<p>Upgrade your plan to get access to more socials and features.</p>
							<div className="replay-button">
								<button className="btn-primary replay" onClick={clickHandler}>
									{actionLabel}
								</button>
							</div>
						</div>
					</div>
				);
			}
		}

		generateDetailStatusBlock(input, messageArray) {
			let statusBlock = null,
				copy = [],
				constants = this.props.app.config.constants,
				now = new Date().getTime(),
				nextPull = 0,
				i = 0,
				key = 0,
				errors = [],
				lastPullCount = '',
				lastPullCountPlural = '',
				messages = [],
				replayPromo = null,
				clickHandler = this.upgradeFromReplay;

			if (parseInt(this.props.app.flags.routeViewType, 10) === constants.ROUTE_VIEW_SIMPLE) {
				if (this.props.isFreeUser() || this.props.isStarterUser()) {
					if (mixpanel) {
						mixpanel.track("Premium Posting View (Slim)")
					}
					if (this.props.recordEvent) {
						this.props.recordEvent({
							pub_id: this.props.user.detail.id,
							event_name: 'Premium Posting Feed Banner View',
							event_data: {
								source: 'Slim'
							}
						})
					}
					replayPromo = (
						<div className="replay-promo">
							<a href="#" onClick={clickHandler} data-source="slim">
								<i className="icon fa fa-star"/>Post more than 50 items per month? Unlock premium posting.
							</a>
						</div>
					);
				} else if (this.props.isBasicUser()) {
					if (mixpanel) {
						mixpanel.track("Add More Socials View (Slim)")
					}
					if (this.props.recordEvent) {
						this.props.recordEvent({
							pub_id: this.props.user.detail.id,
							event_name: 'Add More Socials Feed Banner View',
							event_data: {
								source: 'Slim'
							}
						})
					}
					replayPromo = (
						<div className="replay-promo">
							<a href="#" onClick={clickHandler} data-source="slim">
								<i className="icon ion-android-star-outline"/>Need more socials? Upgrade to expand your plan and get access to more features.
							</a>
						</div>
					);
				}
			}

			if ((this.props.messages !== undefined && this.props.messages !== null && this.props.messages.length) || (messageArray !== undefined && messageArray !== null && messageArray.length)) {
				messages = this.props.messages || messageArray;
				// catch reactivation and other messages here
				if (messages[0].type === "ROUTE_CREATE" && (this.props.isFreeUser() || this.props.isStarterUser() || this.props.isBasicUser())) {
					statusBlock = this.generateReplayBlock();
				} else {
					statusBlock = (
						<MessageModule
							app={this.props.app}
							keys={['ROUTE_CREATE', 'ROUTE_UPDATE', 'INPUT_UPDATE', 'INPUT_REFRESH', 'OUTPUT_UPDATE', 'SOCIAL_UPDATE']}
							render={(state) => {
	                            return (
	                                <div className="detail-status info">
	                                    {state.messages.map((message) => {
	                                        return (
	                                            <div key={message.id}>
	                                                {message.message}
	                                            </div>
	                                        );
	                                    })}
	                                </div>
	                            );
	                        }}/>
					);
				}

			} else if (this.props.newRouteInfo && this.props.newRouteInfo.id) {
				if (this.props.newRouteInfo.isCreated && this.props.newRouteInfo.id === parseInt(this.props.route.id, 10)) {
					if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCED) {
						copy.push(<span key={key++}>{"Your route has been created. We'll share the most recent item from each feed shortly."}</span>);
						statusBlock = <div className="detail-status info">{copy}</div>;
					} else {
						if (this.props.isFreeUser() || this.props.isStarterUser() || this.props.isBasicUser()) {
							statusBlock = this.generateReplayBlock();
						} else {
							copy.push(<span key={key++}>{"Your feed has been created. We'll share the most recent item shortly."}</span>);
							statusBlock = <div className="detail-status info">{copy}</div>;
						}
					}
				}

			} else if (this.state.detailError) {
				copy.push(<span key={key++}>{this.state.detailError}</span>);
				statusBlock = <div className="detail-status error">{copy}</div>;
			} else if (this.props.errorCount > 0) {
				// check for input errors
				errors = errors.concat(ErrorHelper.extractErrors(this.props.route.inputs, 'input'));

				// check for output errors
				errors = errors.concat(ErrorHelper.extractErrors(this.props.route.outputs, 'output'));

				statusBlock = (
					<div className="detail-status error">
						<ul className="error-list">
							{errors.map(function(error, i){
								let errorMessage = '';

								errorMessage = error.message;

								return (
									<li key={i}>
										<i className="fa fa-exclamation-circle error"></i>
										<div className="status-message">{errorMessage}</div>
									</li>
								);
							}, this)}
						</ul>
					</div>
				);
			} else if (this.props.route.tweeterReq == 1 && this.props.route.tweeter == 0) {
				copy.push(<span key={key++}>{"To resume posting to X (Twitter), choose an origin account by clicking ("} <i className="ds-icon icon-x" style={{color: "#000"}}/> {") in the list controls. All other X (Twitter) profiles will retweet the posts from the origin X (Twitter) profile."}</span>);
				statusBlock = <div className="detail-status error">{copy}</div>;
			}

			let outputsActive = false;
			if (this.props.route.outputs.length) {
				for (let i = 0; i < this.props.route.outputs.length; ++i) {
					if (this.props.route.outputs[i].activeFlag === 1  &&
						(this.props.route.outputs[i].social !== undefined &&
						 this.props.route.outputs[i].social.activeFlag == 1 &&
						 this.props.route.outputs[i].social.sysActionFlag === 0)) {
							outputsActive = true;
							break;
					}
				}
			}


			// for simple or curated routes show a pull status
			if (copy.length === 0 &&
				outputsActive &&
				statusBlock === null &&
				(this.props.app.flags.routeViewType == constants.ROUTE_VIEW_SIMPLE ||
					this.props.route.type == constants.R_CURATE_BASIC)) {
				if (input) {
					if (input.lastPullTs !== undefined) {
						if (parseInt(input.lastPullTs) > 1) {
							copy.push(<span>Checked <FormattedRelativeWrapper value={input.lastPullTs * 1000} />. </span>);
							//copy += this.getElapsedTime(this.props.route.inputs[0].lastPullTs, "Checked") + ". ";
						}
					} else if (input.lastPullInfo.length && parseInt(input.lastPullInfo[0].unixTs, 10) > 0) {
						if (parseInt(input.lastPullInfo[0].unixTs) !== 1) {
							copy.push(<span>Checked <FormattedRelativeWrapper value={input.lastPullInfo[0].unixTs * 1000} />. </span>);
							//copy += this.getElapsedTime(this.props.route.inputs[0].lastPullTs, "Checked") + ". ";
						}
					}
					if (input.nextPull && parseInt(input.nextPull, 10) > 0) {
						if (parseInt(input.activeFlag)) {
							nextPull = new Date(parseInt(input.nextPull) * 1000).getTime();
							if (nextPull > now) {
								copy.push(<span>Next check <FormattedRelativeWrapper value={nextPull} />. </span>);
								//copy += this.getElapsedTime(this.props.route.inputs[0].nextPull, "Next check") + ". ";
							}
						}
					}

					if (this.props.route.type == constants.R_CURATE_BASIC) {
						lastPullCount = 'Zero';
						if (input.lastPullInfo.length) {
							if (input.lastPullInfo[0].foundItems > 0) {
								lastPullCount = input.lastPullInfo[0].foundItems;
							}
						}
						lastPullCountPlural = (parseInt(lastPullCount, 0) === 1) ? 'item' : 'items';
						copy.push(<span>{lastPullCount} new {lastPullCountPlural} found.</span>);
					}
				}

				if (copy.length === 0 && outputsActive) {
					copy.push("Checking for new items now.");
				}

				if (copy.length) {
					if (this.props.route.type == constants.R_CURATE_BASIC) {
						statusBlock = <div className="detail-status info">{copy.map((item, i) => <span key={`copy-${i}`}>{item}</span>)}</div>;
					} else {
						statusBlock = <div className="detail-status info">{copy.map((item, i) => <span key={`copy-${i}`}>{item}</span>)}{replayPromo}</div>;
					}
				}



			} else if (copy.length === 0 && statusBlock === null && (this.props.app.flags.routeViewType == constants.ROUTE_VIEW_ADVANCED && parseInt(this.props.route.activeFlag, 10) && this.props.route.type != constants.R_CURATE_BASIC)) {
				if (replayPromo) {
					statusBlock = <div className="detail-status info">{replayPromo}</div>;
				}
			} else if (!outputsActive && copy.length === 0) {
				if (!outputsActive && copy.length === 0 && this.props.route.type !== constants.R_CURATE_BASIC) {
					copy.push(<span>{"No active socials are connected to this feed. Feed checks will resume when an active social is present."}</span>);
					statusBlock = <div className="detail-status inactive">{copy.map((item, i) => <span key={`copy-${i}`}>{item}</span>)}</div>;
				}
			}

			return statusBlock;
		}

		render() {
			return (
				<Component
					{...this.props}
					activeRouteToggleClick={this.activeRouteToggleClick}
					setReactivationAction={this.setReactivationAction}
					reactivateRoute={this.reactivateRoute}
					reactivateInput={this.reactivateInput}
					getReactivateBlock={this.getReactivateBlock}
					reauthorizeInput={this.reauthorizeInput}
					upgradeFromReplay={this.upgradeFromReplay}
					generateReplayBlock={this.generateReplayBlock}
					generateDetailStatusBlock={this.generateDetailStatusBlock}
					reactivating={this.state.reactivating}
					reactivatingInput={this.state.reactivatingInput}
					startReactivation={this.startReactivation}
					setDetailError={this.setDetailError}
				/>
			);
		}
	}

	RouteDetailModule.displayName = "RouteDetailModule";

	return RouteDetailModule;

}
